// extracted by mini-css-extract-plugin
export var lg = "_m-7";
export var md = "_m-6";
export var placeholderContainer = "_m-1";
export var placeholderIcon = "_m-2";
export var productImage = "_m-0";
export var sm = "_m-5";
export var xs = "_m-4";
export var xxs = "_m-3";